import { Box } from '@cko/primitives';
import styled from 'styled-components';
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
export const FormFieldContainer = styled(Box) `
  &:not(:last-child) {
    margin-bottom: var(--layout-soybean);
  }
`;
